import { render, staticRenderFns } from "./CreateEditIntegration.vue?vue&type=template&id=86534768&scoped=true&"
import script from "./CreateEditIntegration.vue?vue&type=script&lang=ts&"
export * from "./CreateEditIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditIntegration.vue?vue&type=style&index=0&id=86534768&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86534768",
  null
  
)

export default component.exports